import { useState } from "react";
import Button from "../Buttons/Button";
import FormFieldSet from "../FormFields/FormFieldSet";
import {
  ATS_API_URL,
  MAIN_API_URL,
  WORKFORCE_API_URL,
  BENCHSALES_API_URL,
} from "../../redux/apiConfig";
import { useLoginUser } from "../../hooks/useLoginUser";
import axiosRequest from "../../redux/slices/universal/axiosService";
import useFormHandler from "../Validations/useFormHandler";
const AddOptionPopup = ({ onClose, onAdd, existingOptions, alertName }) => {
  const [label, setLabel] = useState("");
  const [secondaryValue, setSecondaryValue] = useState(""); // For additional fields
  const [error, setError] = useState("");
  const [secondaryError, setSecondaryError] = useState("");
  const [validError, setValidError] = useState(false);
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;

  const handleDefaultSubmit = () => {
    alert("Please contact admin to add new option");
  };
  const API_BASES = {
    workforce: WORKFORCE_API_URL,
    ats: ATS_API_URL,
    master: MAIN_API_URL, // define MASTER_API_URL somewhere
    benchsales: BENCHSALES_API_URL,
  };
  // Generic function to handle adding options
  const handleAddOption = async ({
    endpoint,
    itemType,
    type = "workforce",
  }) => {
    // const valid = validateAllFields()
    const trimmedLabel = label.trim();
    let isValid = true;
    // if (!trimmedLabel || !valid) {
    if (!trimmedLabel) {
      setError("Please enter a valid option.");
      isValid = false;
    }
    if (!isValid) return;
    // Function to capitalize the first letter of each word
    const capitalizeWords = (str) => {
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    const formattedLabel = capitalizeWords(trimmedLabel);
    const normalizedInput = formattedLabel.replace(/\s+/g, "").toLowerCase();
    const isDuplicate = existingOptions.some(
      (option) =>
        option.label.replace(/\s+/g, "").toLowerCase() === normalizedInput
    );

    if (isDuplicate) {
      setError("This option already exists!");
      return;
    }
    // const apiUrl =
    //   type === "workforce"
    //     ? `${WORKFORCE_API_URL}/dropdown/${endpoint}`
    //     : `${ATS_API_URL}/dropdown/${endpoint}`;
    const apiUrl = `${
      API_BASES[type] || WORKFORCE_API_URL
    }/dropdown/${endpoint}`;
    if (!isDuplicate) {
      // const url = `${WORKFORCE_API_URL}/dropdown/${endpoint}`;
      const url = apiUrl;
      const body = {
        addedBy: loginUserUiid,
        title: formattedLabel, // Use the formatted label
      };
      try {
        const token = localStorage.getItem("token");
        // const response = await axios.post(url, body, {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //     "Content-Type": "application/json",
        //   },
        //   withCredentials: true,
        // });
        const response = await axiosRequest({
          method: "POST",
          url,
          data: body,
        });

        // Create the option object for the UI
        let optionData = { label: formattedLabel, value: formattedLabel };
        onAdd(optionData);

        setLabel(""); // Reset input field
        onClose(); // Close the popup
      } catch (error) {
        console.error(`Error submitting ${itemType}:`, error);
        setError(`Failed to add ${itemType}. Please try again.`);
      }
    }
  };

  const handleAddCompanyName = () =>
    handleAddOption({
      endpoint: "company", //  confirm endpoint name
      itemType: "bs_company_name",
      type: "benchsales", // or "workforce" based on your API
    });

  // Specific handlers that use the generic function
  const handleAddJobTitles = () =>
    handleAddOption({ endpoint: "jobtitles", itemType: "Job title" });
  const handleAddATSJobTitles = () =>
    handleAddOption({
      endpoint: "jobtitles",
      itemType: "Job title",
      type: "ats",
    });
  const handleAddDocumentType = () =>
    handleAddOption({ endpoint: "documenttypes", itemType: "Document type" });
  const handleAddJobNetTerms = () =>
    handleAddOption({ endpoint: "netTerms", itemType: "Net Terms" });
  const handleAddClientCategories = () =>
    handleAddOption({
      endpoint: "clientCategories",
      itemType: "Client Categories",
    });
  const handleAddJobTerminationNotices = () =>
    handleAddOption({
      endpoint: "jobTerminationNotices",
      itemType: "JobTermination Notices",
    });
  const handleAddContactTypes = () =>
    handleAddOption({ endpoint: "contactTypes", itemType: "AddContact Types" });
  const handleAddRoleTypes = () =>
    handleAddOption({ endpoint: "roleTypes", itemType: "Role Types" });
  const handleAddPlacementsList = () =>
    handleAddOption({
      endpoint: "placementsList",
      itemType: "Placements List",
    });
  const handleAddDeductions = () =>
    handleAddOption({ endpoint: "deductions", itemType: "Deductions List" });
  const handleAddJobRoles = () =>
    handleAddOption({ endpoint: "jobRoles", itemType: "JobRoles List" });
  const handleAddExpensesTypes = () =>
    handleAddOption({ endpoint: "expensesTypes", itemType: "Expenses List" });
  const handleAddPaymentMethods = () =>
    handleAddOption({
      endpoint: "paymentMethods",
      itemType: "Payment Methods",
    });
  const handleAddDepositTo = () =>
    handleAddOption({ endpoint: "depositTo", itemType: "Deposit To" });
  const handleAddIndustry = () =>
    handleAddOption({
      endpoint: "industry",
      itemType: "Industry",
      type: "ats", // Assuming Industry is part of ATS late we will change it to master
    });
  const handleAddATSLocation = () =>
    handleAddOption({
      endpoint: "states",
      itemType: "states",
      type: "ats",
    });
    const handleAddBDMLocation = () =>
    handleAddOption({
      endpoint: "cities",
      itemType: "cities",
      type: "ats",
    });

    const { errors, handleChange, validateAllFields } = useFormHandler(
    {
      atsjobtitle: "",
    },
    {
      atsjobtitle: { type: "text", required: true },
    }
  );
  let modalTitle = "Add New Option";
  let formFields = [
    {
      type: "text",
      title: "Add New",
      value: label,
      onChange: setLabel,
      placeholder: "Enter your new option",
      error: error,
      icon: "add",
      disabled: false,
    },
  ];
  let submitFunction = handleDefaultSubmit;

  // Switch case based on alertName to set appropriate title and fields
  switch (alertName) {
    case "addJobTitles":
      modalTitle = "Add New Job Title";
      formFields = [
        {
          type: "text",
          title: "Job Title",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new job title",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddJobTitles;

      break;
    case "addAtsJobTitle":
      modalTitle = "Add New Job Title";
      formFields = [
        {
          type: "text",
          title: "Job Title",
          value: label,
          onChange: (value) => {
            handleChange("atsjobtitle", value); // validation
            setLabel(value);                    // update label
          },
          placeholder: "Enter new job title",
          error: errors?.atsjobtitle || error,
          icon: "add",
        },
      ];
      submitFunction = handleAddATSJobTitles;
      break;
    case "addNetTerms":
      modalTitle = "Add New Net Terms";
      formFields = [
        {
          type: "text",
          title: "Net Terms",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new net terms",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddJobNetTerms;
      break;
    case "addRoleTypes":
      modalTitle = "Add New RoleTypes";
      formFields = [
        {
          type: "text",
          title: "Role Types",
          value: label,
          onChange: setLabel,
          placeholder: "Enter New Type",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddRoleTypes;
      break;
    case "addDocumentType":
      modalTitle = "Add New Document Type";
      formFields = [
        {
          type: "text",
          title: "Document Type",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new Document Type",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddDocumentType;
      break;
    case "addClientCategories":
      modalTitle = "Add New Client Categories";
      formFields = [
        {
          type: "text",
          title: "Client Categories",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new client categories",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddClientCategories;
      break;
    case "addJobTerminationNotices":
      modalTitle = "Add New JobTermination Notices";
      formFields = [
        {
          type: "text",
          title: "JobTermination Notices",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new JobTermination Notices",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddJobTerminationNotices;
      break;
    case "addContactTypes":
      modalTitle = "Add New ContactTypes";
      formFields = [
        {
          type: "text",
          title: "addContact Types",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new ContactTypes",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddContactTypes;
      break;
    case "addPlacementsList":
      modalTitle = "Add New PlacementsList";
      formFields = [
        {
          type: "text",
          title: "add Placements",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new add Placements",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddPlacementsList;
      break;
    case "addDeductions":
      modalTitle = "Add New Deductions";
      formFields = [
        {
          type: "text",
          title: "add addDeductions",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new add Deductions",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddDeductions;
      break;
    case "addJobRoles":
      modalTitle = "Add New JobRoles";
      formFields = [
        {
          type: "text",
          title: "add JobRoles",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new add JobRoles",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddJobRoles;
      break;
    case "addExpensesTypes":
      modalTitle = "Add New ExpensesTypes";
      formFields = [
        {
          type: "text",
          title: "add ExpensesTypes",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new add ExpensesTypes",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddExpensesTypes;
      break;
    case "addPaymentMethods":
      modalTitle = "Add New Payment Methods";
      formFields = [
        {
          type: "text",
          title: "add Payment Methods",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new add Payment Methods",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddPaymentMethods;
      break;
    case "addDepositTo":
      modalTitle = "Add New DepositTo";
      formFields = [
        {
          type: "text",
          title: "add Payment Methods",
          value: label,
          onChange: setLabel,
          placeholder: "Enter new add DepositTo",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddDepositTo;
      break;

    case "addIndustry":
      modalTitle = "Add New Industry";
      formFields = [
        {
          type: "text",
          title: "Add Industry",
          value: label,
          // onChange: (value) => {
          //   handleChange("industry", value); // validation
          //   setLabel(value);                    // update label
          //   // const valid = /^[A-Za-z]+$/.test(value);
          //   // if (valid && value.trim() != "") {
          //   //   setError("");
          //   //   setValidError(false)
          //   // }else{
          //   //     setValidError(true)
          //   // }
          // },
          onChange: setLabel,
          placeholder: "Enter new add Industry",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddIndustry;
      break;
    case "addCompanyName":
      modalTitle = "Add New Company";
      formFields = [
        {
          type: "text",
          title: "Company Name",
          value: label,
          onChange: setLabel,
          placeholder: "Enter company name",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddCompanyName;
      break;
    case "states":
      modalTitle = "states";
      formFields = [
        {
          type: "text",
          title: "State Full Name",
          value: label,
          onChange: setLabel,
          placeholder: "Enter Name",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddATSLocation;
      break;
      case "cities":
      modalTitle = "cities";
      formFields = [
        {
          type: "text",
          title: "State Full Name",
          value: label,
          onChange: setLabel,
          placeholder: "Enter Name",
          error: error,
          icon: "add",
        },
      ];
      submitFunction = handleAddBDMLocation;
      break;


    default:
      // Default values already set above
      break;
  }

  /////////////////////////////////
  /////////////////////////////////

  return (
    <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-[999]">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-lg font-bold mb-4">{modalTitle}</h2>

        <div className="mb-3 space-y-3">
          {formFields.map((field, index) => (
            <FormFieldSet
              key={index}
              type={field.type}
              title={field.title}
              value={field.value}
              onChange={field.onChange}
              placeholder={field.placeholder}
              error={field.error}
              icon={field.icon}
              disabled={field.disabled}
            />
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button onClick={onClose} title="Cancel" variant="outlined" />
          {/* <Button onClick={handleSubmit} title="Add" variant="contained" /> */}
          <Button onClick={submitFunction} title="Add" variant="contained" />
        </div>
      </div>
    </div>
  );
};

export default AddOptionPopup;